import CLASS_NAMES from "../constants/css-constants.es6.js";
import { DOM_EVENTS } from "../constants/html-constants.es6.js";
import { KEYS } from "../constants/js-constants.es6.js";

export default class Tab {
  #$tabElement;

  #selectionHandler;

  constructor({
    /**
     * the jQuery object representing the tab element of interest
     */
    $tabElement,
    /**
     * whether or not this tab should be selected by default
     */
    selected,
    /**
     * the callback function for when the button is clicked
     */
    selectionHandler,
  }) {
    this.#$tabElement = $tabElement;
    this.#selectionHandler = selectionHandler;

    this.#setEventListeners();

    if (selected) {
      this.#select();
    }
  }

  #setEventListeners() {
    this.#$tabElement.on(DOM_EVENTS.CLICK, event => {
      event.preventDefault();
      this.#select();
    });

    this.#$tabElement.on(DOM_EVENTS.KEYPRESS, event => {
      if (event.key === KEYS.ENTER) {
        event.preventDefault();
        this.#select();
      }
    });
  }

  #select() {
    this.#$tabElement.addClass(CLASS_NAMES.SELECTED);
    this.#unselectSiblings();
    this.#selectionHandler();
  }

  #unselectSiblings() {
    const $siblings = this.#$tabElement.siblings();
    $siblings.removeClass(CLASS_NAMES.SELECTED);
  }
}
